import React from 'react'
import {Col, Row, Statistic} from "antd";

const Bids = ({data}) => {

    const {nb, pb, wb} = data
    return (
        <React.Fragment>
            <Row>
                <Col span={8}>
                    <Statistic title={'Olumlu Teklif'} value={pb}/>
                </Col>
                <Col span={8}>
                    <Statistic title={'Olumsuz Teklif'} value={nb}/>
                </Col>
                <Col span={8}>
                    <Statistic title={'Bekleyen Teklif'} value={wb}/>
                </Col>
            </Row>
        </React.Fragment>
    )
}
export default Bids